import React, { useContext } from 'react'
import { TransactionDto } from 'api/Transaction/Types/Transaction'
import { errorToast, ToastContext } from 'components/Toast/Toast'

import { useTransactionReverseForm } from './TransactionReversePage'
import { WalletTransactionReverseForm } from './WalletTransactionReverseForm'

interface TransactionReverseProps {
  transaction: TransactionDto

  onClose(): void
}

const WalletTransactionReversePage: React.FC<TransactionReverseProps> = (props) => {
  const { onSubmit } = useTransactionReverseForm(props)
  const setToast = useContext(ToastContext)

  if (isWalletTransaction(props)) {
    setToast(
      errorToast(`Cannot find Wallet Transaction in transaction ${props.transaction.referenceId}`)
    )
    props.onClose()
    return null
  }

  return <WalletTransactionReverseForm transaction={props.transaction} onSubmit={onSubmit} />
}

const isWalletTransaction = (props: TransactionReverseProps) => {
  return !props.transaction.walletTransactions || !props.transaction.walletTransactions.length
}

export default WalletTransactionReversePage
